import { graphqlFetch } from '@/utils/graphqlFetch';
import { FinancialAnalyticOutput, PeriodFilterInput } from '../gql/graphql';
import { useQuery } from '@tanstack/react-query';
import { GET_FINANCE_ANALYTICS } from '../queries';

export const useGetFinanceAnalytic = (period: PeriodFilterInput) => {
  return useQuery<{ data: FinancialAnalyticOutput }, Error>({
    queryKey: ['finance', period],
    queryFn: async () => {
      const data = await graphqlFetch<
        { getFinancialAnalytic: FinancialAnalyticOutput },
        { period: PeriodFilterInput }
      >(GET_FINANCE_ANALYTICS, { period });
      return {
        data: data.getFinancialAnalytic,
      };
    },
  });
};
